define(
  'CustomMyAccountData.Main.EntryPoint', [
    'custommyaccountdata_order_history.tpl',
    'custommyaccountdata_return_authorization.tpl',
    'custommyaccountdata_invoices.tpl',
    'custommyaccountdata_quotes.tpl',
    'Custom.Order.History.View',
    'CustomMyAccountData.Second.EntryPoint'
  ], function (
    TemplateOrderHistory,
    TemplateReturnAuthorization,
    TemplateInvoices,
    TemplateQuotes,
    CustomOrderHistoryView,
    CustomMyAccountDataNewViews
  ) {
    'use strict';

    return {
      mountToApp: function mountToApp(container) {
        var layout = container.getComponent('Layout');
        var environment = container.getComponent('Environment');
        var config = environment && environment.getConfig('CustomMyAccount');
        var OrderHistoryListView = {};
        var ReturnAuthorizationListView = {};
        var InvoiceOpenListView = {};
        var QuoteListView = {};

        if(layout) {
          if(config) {
            try {
              if(config.orders) {
                OrderHistoryListView = require('OrderHistory.List.View');
                _.extend(OrderHistoryListView.prototype, {
                  template: TemplateOrderHistory
                });

                layout.addChildView('CustomOrder.History', function () {
                  return new CustomOrderHistoryView({
                    application: container,
                    trantype: 'orders',
                    title: 'Purchase History'
                  });
                });
              }
              if(config.returns) {
                ReturnAuthorizationListView = require('ReturnAuthorization.List.View');
                _.extend(ReturnAuthorizationListView.ReturnAuthorizationListView.prototype, {
                  template: TemplateReturnAuthorization
                });

                layout.addChildView('CustomReturn.Authorization', function () {
                  return new CustomOrderHistoryView({
                    application: container,
                    trantype: 'returns',
                    title: 'Return History',
                    isReturn: true
                  });
                });
              }
              if(config.invoices) {
                InvoiceOpenListView = require('Invoice.OpenList.View');
                _.extend(InvoiceOpenListView.prototype, {
                  template: TemplateInvoices
                });

                layout.addChildView('Custom.Invoices', function () {
                  return new CustomOrderHistoryView({
                    application: container,
                    trantype: 'invoices',
                    title: 'Invoices'
                  });
                });
              }
              if(config.quotes) {
                QuoteListView = require('Quote.List.View');
                _.extend(QuoteListView.prototype, {
                  template: TemplateQuotes
                });

                layout.addChildView('Custom.Quotes', function () {
                  return new CustomOrderHistoryView({
                    application: container,
                    trantype: 'quotes',
                    title: 'Quotes'
                  });
                });
              }

              CustomMyAccountDataNewViews.mountToApp(container);

            } catch (e) {
              console.log(e);
            }
          }
        }

      }
    };
  });
